import Button from 'src/components/primitives/Button/Button';
import SecondaryConnectWalletButton from 'src/components/SecondaryConnectWalletButton';
import { useSpotMarkets } from 'src/hooks/spotMarkets/useSpotMarkets';

import { InsuranceFundListData } from './types';
import useActionButtons from '../useActionButtons';
import { PageRoute } from 'src/constants/constants';
import { WithClassName } from 'src/utils/UtilityTypes';

interface ActionButtonsProps extends WithClassName {
	row: InsuranceFundListData;
	isPortfolioPage?: boolean;
}

const ActionButtons = ({ row, isPortfolioPage }: ActionButtonsProps) => {
	const spotMarkets = useSpotMarkets();
	const spotMarket = spotMarkets[row.marketIndex];

	const {
		connected,
		accountIsDelegate,
		isStakeDisabled,
		submitting,
		requestWithdrawPaused,
		withdrawPaused,
		unstakeInProgress,
		canWithdraw,
		currentStake,
		handleClickStakeButton,
		handleClickUnstakeButton,
	} = useActionButtons({ ifData: row.ifData, spotMarket });

	if (!spotMarket || !row.ifData) {
		return null;
	}

	if (!connected) {
		return (
			<div className="flex w-full items-center justify-end">
				<SecondaryConnectWalletButton />
			</div>
		);
	}

	return (
		<div className="flex w-full flex-row items-center justify-end gap-x-xs">
			{isPortfolioPage && (
				<Button
					size="sm"
					variant="secondary"
					className="flex-1"
					as="a"
					href={`/${PageRoute.vaults}/insurance-fund-vaults`}
					onClick={(e) => e.stopPropagation()}
				>
					Manage
				</Button>
			)}

			{!isPortfolioPage && (
				<>
					{!unstakeInProgress && (
						<Button
							variant="secondary"
							size="sm"
							onClick={handleClickStakeButton}
							isLoading={submitting}
							disabled={isStakeDisabled}
						>
							Stake
						</Button>
					)}
					<Button
						variant="secondary"
						size="sm"
						isLoading={submitting}
						disabled={
							currentStake === 0 ||
							submitting ||
							accountIsDelegate ||
							(unstakeInProgress && canWithdraw && withdrawPaused) ||
							(!unstakeInProgress && requestWithdrawPaused)
						}
						onClick={handleClickUnstakeButton}
					>
						{unstakeInProgress
							? canWithdraw
								? 'Withdraw'
								: 'Cancel Unstake'
							: 'Unstake'}
					</Button>
				</>
			)}
		</div>
	);
};

export default ActionButtons;
